import { connect, useSelector } from "react-redux";
import { State } from "redux/store";
import classNames from "classnames";
import { useMemo, useRef, useState } from "react";
import { useLocation, useParams } from "react-router";
import {
  getIsImageUploading,
  getIsUserConfigLoaded,
  getIsUserConfigLoading,
  getSimilarityVertexCluster,
  isImageSearchEnabled,
} from "redux/SingleDataset/selectors";
import { LABEL_CLASS_PARAMETER } from "helpers/constants/miscellaneous";
import SearchContainer from "./SearchContainer";
import ClusterDetailsFilter from "./ClusterDetailsFilter";
import styles from "./style.module.scss";
import AddFilterButton from "./AddFiltersButton";
import { useClearSavedSearchParam } from "../../../../../hooks/useClearSavedSearchParam";

const DataPageFilters = ({
  isVertexSelected,
  imageSearchEnabled,
  isImageUploading,
  isUserConfigLoading,
}: any) => {
  const isDatasetConfigLoaded = useSelector(getIsUserConfigLoaded);
  const { datasetId, clusterId } = useParams();
  const [isClearFiltersCalled, setIsClearFiltersCalled] = useState(false);
  const location = useLocation();
  const searchContainerRef = useRef<HTMLDivElement>(null);

  const filterSectionClassnames = classNames(styles.filterSection, {
    [styles.disabledFilterSection]: isImageUploading,
    [styles.loadingHeight]: !isDatasetConfigLoaded,
  });

  const searchParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search],
  );

  const labelId = searchParams.get(LABEL_CLASS_PARAMETER);
  const showClusterFilter = (!!clusterId || !!labelId) && !!datasetId;
  const hideEntityFilter = (datasetId && clusterId) || isVertexSelected;

  const showEntityTypeLoader = isUserConfigLoading;

  useClearSavedSearchParam();

  const renderFilterSection = () => {
    if (isDatasetConfigLoaded) {
      return (
        <div className={styles.filterSectionLeft}>
          {/*<SavedViewsFilter />*/}
          <div className={styles.filterWrapper}>
            <SearchContainer
              containerRef={searchContainerRef}
              datasetId={datasetId!}
              isImageUploading={isImageUploading}
              hideEntityFilter={hideEntityFilter}
              imageSearchEnabled={imageSearchEnabled}
              isUserConfigLoading={isUserConfigLoading}
              isClearFiltersCalled={isClearFiltersCalled}
              showEntityTypeLoader={showEntityTypeLoader}
              setIsClearFiltersCalled={setIsClearFiltersCalled}
            />
          </div>
          <AddFilterButton />
          {/*<SaveViewButton className={styles.saveViewButton} />*/}
          {showClusterFilter && <ClusterDetailsFilter />}
          <div className={styles.filler} />
        </div>
      );
    } else {
      return <div className={styles.filterSkeleton}></div>;
    }
  };

  return (
    <div className={filterSectionClassnames}>
      {!isUserConfigLoading && renderFilterSection()}
    </div>
  );
};

const mapStatesToProps = (state: State) => {
  return {
    isUserConfigLoading: getIsUserConfigLoading(state),
    isVertexSelected: !!getSimilarityVertexCluster(state),
    imageSearchEnabled: isImageSearchEnabled(state),
    isImageUploading: getIsImageUploading(state),
  };
};

export default connect(mapStatesToProps)(DataPageFilters);
